import * as React from 'react'
import { useParams } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { PerformanceReviewProcessTargetForPeerAssignmentDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import Loading from 'modules/layout/components/Page/Loading'
import { CompletionBarWithTitle } from 'modules/performance_process/components/common/CompletionBarWithTitle'
import ProcessTargetForPeerAssignmentDataTable from 'modules/performance_process/components/peerAssignments/ProcessTargetForPeerAssignmentDataTable'

export const PeerAssignment: React.FC = () => {
  const { reviewId } = useParams()
  const { data, loading, error } = useQuery(
    PerformanceReviewProcessTargetForPeerAssignmentDocument,
    {
      variables: { id: Number(reviewId) },
    }
  )

  const review = data?.performance.reviewProcess

  if (!review) return null

  //Peer assigments totals data
  const totalPendingTargetsForPeerAssignment = review.pendingTargetsForPeerAssignment.totalCount
  const totalTargetsForPeerAssignment = review.targetsForPeerAssignment.totalCount

  const canAddPeers = review.status == 'active'

  if (loading || error) return <Loading />

  return (
    <Box gap="s32">
      <Box gap="s12">
        <Text size="500" weight="semibold" color="grey1000">
          {i18n.t('performance_process.reviews.peer_management.peer_assignments_title')}
        </Text>
        <Text.Normal>
          {i18n.t('performance_process.reviews.peer_management.peer_assignments_description')}
        </Text.Normal>
      </Box>

      <Box gap="s48">
        {totalPendingTargetsForPeerAssignment != null && totalTargetsForPeerAssignment != null && (
          <CompletionBarWithTitle
            completed={totalTargetsForPeerAssignment - totalPendingTargetsForPeerAssignment}
            total={totalTargetsForPeerAssignment}
          />
        )}
        <ProcessTargetForPeerAssignmentDataTable canAddPeers={canAddPeers} />
      </Box>
    </Box>
  )
}
